import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'

import { InfiniteScrollDirective } from 'ngx-infinite-scroll'

import { ComponentsModule } from '../../components/components.module'
import { FormatAuthorNamePipe } from '../../shared/pipes/format-author-name.pipe'
import { SharedModule } from '../../shared/shared.module'
import { EditorItemComponent } from './editors-overview/components/editor-item/editor-item.component'
import { EditorsListComponent } from './editors-overview/components/editors-list/editors-list.component'
import { EditorsOverviewComponent } from './editors-overview/editors-overview.component'
import { EditorsRoutingModule } from './editors-routing.module'

@NgModule({
  imports: [
    CommonModule,
    EditorsRoutingModule,
    ComponentsModule,
    RouterModule,
    SharedModule,
    InfiniteScrollDirective,
    FormatAuthorNamePipe,
    EditorsOverviewComponent,
    EditorsListComponent,
    EditorItemComponent,
  ],
})
export class EditorsModule {}
